const ErrorFormModal = () => {
    const handleRefreshClick = () => {
        window.location.reload();
    };

    return (
        <div className={'error-from__modal'}>
            <h2>Произошла ошибка с сервером <br/> перезагрузите страницу</h2>
            <button onClick={handleRefreshClick}>
                Обновить страницу
            </button>
        </div>
    );
}

export default ErrorFormModal